import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export function sendRoomBecomeAMemberAnalytic() {
    const eventData = {
        type: AnalyticEventType.ABTestClickAnalytics,
        category: AnalyticEventCategory.ABTestClickAnalytics,
        floatValue: AnalyticEventValue.RoomBecomeAMemberButton
    };
    void CA.sendAnalyticEvent(eventData);
}
